// The reminders section's colour. The home tile, the page, the dot on the home
// calendar and the bell's notice all wear it, so the four read as one thing.
// Home.js writes it as the class bg-[#A0522D], which has to stay a literal for
// Tailwind to find it; change both together.
export const REMINDER_COLOR = "#A0522D";
